import baseAPIAction from "REDUX/BaseAPIAction";
/* import { API } from "CONSTANTS/AppConstants";
 */ import { Strings } from "INTL/i18n";
import { API_RESPONSE_STATUS_CODE } from "../../../config/axios.init";

export default function makePaymentForCyberSource(
  URL,
  params,
  makePaymentActionCallback
) {
  const API_Call_Details = URL;

  return function(dispatch) {
    const config = {
      Accept: "application/json, text/plain, */*",
      "Content-Type": "application/x-www-form-urlencoded",
      withCredentials: true,
    };

    let formData = new FormData();

    for (let param in params) {
      formData.append(param, params[param]);
    }

    baseAPIAction(
      API_Call_Details,
      makePaymentAPICallback,
      config,
      "post",
      formData
    );
    function makePaymentAPICallback(errorMessage, responseData) {
      if (errorMessage === "") {
        if (responseData.status !== API_RESPONSE_STATUS_CODE.SUCCESS) {
          if (responseData.status === API_RESPONSE_STATUS_CODE.TOKEN_EXPIRED)
            errorMessage = Strings("tokenExpiredMakeNewRequest");
          else if (
            responseData.status === API_RESPONSE_STATUS_CODE.TOKEN_NOT_FOUND
          )
            errorMessage = Strings("tokenNotFound");
          else if (
            responseData.status ===
            API_RESPONSE_STATUS_CODE.TOKEN_ALREADY_PROCESSED
          )
            errorMessage = Strings("tokenAlreadyProcessed");
          else if (
            responseData.status ===
            API_RESPONSE_STATUS_CODE.MAXIMUM_RETRY_ATTEMPTS_REACHED
          )
            errorMessage = Strings("maximumRetryAttemptReached");
          else if (
            responseData.status === API_RESPONSE_STATUS_CODE.KNET_INIT_FAIL
          )
            errorMessage = Strings("knetInitFailed");
          else errorMessage = Strings("internalError");
        }
      }
      makePaymentActionCallback(errorMessage, responseData);
    }
  };
}



// WEBPACK FOOTER //
// ./src/modules/Payer/actions/MakePaymentForCyberSource.js